import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import {
    DeviceRateCorrectionType,
    EditorDeviceRateCorrectionCondition,
    RateControlValue,
    RateCorrectionConditionChooserItemsGroup,
    RateCorrectionConditionId,
    RateCorrectionType
} from '../../../typings/ratesCorrections';
import { RateControl } from '../../RateControl/RateControl';
import { RateCorrectionConditionChooserView } from '../../RateCorrectionConditionChooser/RateCorrectionConditionChooser';
import { RateCorrectionConditionSelector } from '../../RateCorrectionConditionSelector/RateCorrectionConditionSelector';

import './RatesCorrectionsListDeviceCondition.css';

export type onChangeDeviceConditionParams = {
    type: RateCorrectionType.device;
    value: EditorDeviceRateCorrectionCondition;
    id: RateCorrectionConditionId;
};

export interface RatesCorrectionsListDeviceConditionProps {
    value: EditorDeviceRateCorrectionCondition;
    maxRate?: number;
    minRate?: number;
    isDisabled: boolean;
    chooserData: Array<RateCorrectionConditionChooserItemsGroup>;
    disabledChooserDataItems: Array<string>;
    isChooserDisabled: boolean;
    onChange: (params: onChangeDeviceConditionParams) => void;
}

const blockClass = 'rates-corrections-list-device-condition';

export class RatesCorrectionsListDeviceCondition extends React.PureComponent<RatesCorrectionsListDeviceConditionProps> {
    render() {
        const {
            chooserData,
            isDisabled,
            minRate,
            maxRate,
            value,
            disabledChooserDataItems,
            isChooserDisabled
        } = this.props;

        return (
            <div className={blockClass}>
                <RateCorrectionConditionSelector
                    cls={Bem.cls(blockClass, 'selector')}
                    view={RateCorrectionConditionChooserView.default}
                    value={[value.deviceType]}
                    isDisabled={isDisabled || isChooserDisabled}
                    items={chooserData}
                    disabledItems={disabledChooserDataItems}
                    onChange={this.onRateCorrectionConditionChooserChange}
                />

                <RateControl
                    value={value.value}
                    max={maxRate}
                    min={minRate}
                    isDisabled={isDisabled}
                    isCommon={false}
                    errors={value.errors.value}
                    onChange={this.onRateControlChange}
                />
            </div>
        );
    }

    private onRateCorrectionConditionChooserChange = (values: Array<string>) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.device,
            id: value.id,
            value: {
                ...value,
                deviceType: values[0] as DeviceRateCorrectionType
            }
        });
    };

    private onRateControlChange = (rate: RateControlValue) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.device,
            id: value.id,
            value: {
                ...value,
                value: rate
            }
        });
    };
}
